import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  overflow-x: scroll;
  padding-left: ${theme.spacing(1)};

  @media (max-width: ${breakpoints.xsmall.max}px) {
    padding-left: 0;
  }
`;
